const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"dbe7df628755d3ed7689811a3abb7be05716838e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["webapp@ludus"]={id:"dbe7df628755d3ed7689811a3abb7be05716838e"};
      